// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Design Tokens - Z-Index */
/* All --vnsc-z-* tokens */

/* H0.8: \`.vnsc-root\` — the document-root selector never matches inside the
   widget's Shadow DOM (useShadowDOM defaults on), so tokens resolved to "". */
.vnsc-root {
  /* Base Z-Index Scale */
  --vnsc-z-0: 0;
  --vnsc-z-1: 1;
  --vnsc-z-2: 2;
  --vnsc-z-3: 3;
  --vnsc-z-4: 4;
  --vnsc-z-5: 5;
  --vnsc-z-10: 10;
  --vnsc-z-20: 20;
  --vnsc-z-30: 30;
  --vnsc-z-40: 40;
  --vnsc-z-50: 50;

  /* Semantic Z-Index Layers */
  --vnsc-z-background: 0;
  --vnsc-z-content: 1;
  --vnsc-z-raised: 10;
  --vnsc-z-overlay: 20;
  --vnsc-z-modal: 30;
  --vnsc-z-popover: 40;
  --vnsc-z-tooltip: 50;
  --vnsc-z-toast: 60;
  --vnsc-z-maximum: 9999;

  /* Component-specific Z-Index */
  --vnsc-z-chart-canvas: 1;
  --vnsc-z-chart-overlay: 10;
  --vnsc-z-chart-crosshair: 15;
  --vnsc-z-chart-tooltip: 20;
  --vnsc-z-chart-drawing: 25;
  --vnsc-z-chart-selection: 30;
  --vnsc-z-chart-measurement: 35;
  --vnsc-z-chart-x-axis: 40;
  --vnsc-z-chart-pane-tooltip: 45;

  --vnsc-z-toolbar: 50;
  --vnsc-z-header: 55;
  --vnsc-z-footer: 55;
  --vnsc-z-dock: 60;
  --vnsc-z-dock-flyout: 65;
  --vnsc-z-drawing-toolbar: 70;
  --vnsc-z-drawing-inspector: 75;
  --vnsc-z-drawing-list: 75;
  --vnsc-z-drawing-context-menu: 80;

  --vnsc-z-panel: 85;
  --vnsc-z-panel-content: 90;
  --vnsc-z-modal-backdrop: 95;
  --vnsc-z-modal: 100;
  --vnsc-z-modal-content: 105;

  --vnsc-z-popover: 110;
  --vnsc-z-popover-content: 115;
  --vnsc-z-tooltip: 120;
  --vnsc-z-tooltip-content: 125;

  --vnsc-z-toast: 130;
  --vnsc-z-toast-content: 135;

  --vnsc-z-ads-banner: 95;
  --vnsc-z-ads-popup: 99;
  --vnsc-z-trademark: 100;

  /* Sidebar Z-Index */
  --vnsc-z-sidebar: 48;
  --vnsc-z-sidebar-splitter: 49;
  --vnsc-z-sidebar-content: 50;

  /* Bottom Panel Z-Index */
  --vnsc-z-bottom-panel: 40;
  --vnsc-z-bottom-panel-content: 41;

  /* Drawing Dock Z-Index */
  --vnsc-z-drawing-dock: 50;
  --vnsc-z-drawing-dock-header: 51;
  --vnsc-z-drawing-dock-content: 52;
  --vnsc-z-drawing-dock-flyout: 55;

  /* Settings Modal Z-Index */
  --vnsc-z-settings-modal: 100;
  --vnsc-z-settings-modal-content: 101;
  --vnsc-z-settings-modal-tabs: 102;

  /* Snapshot Preview Modal Z-Index */
  --vnsc-z-snapshot-modal: 100;
  --vnsc-z-snapshot-modal-content: 101;

  /* Alerts Modal Z-Index */
  --vnsc-z-alerts-modal: 100;
  --vnsc-z-alerts-modal-content: 101;

  /* Symbol Search Z-Index */
  --vnsc-z-symbol-search: 80;
  --vnsc-z-symbol-search-results: 81;

  /* Whale Panel Z-Index */
  --vnsc-z-whale-panel: 60;
  --vnsc-z-whale-panel-content: 61;

  /* Context Rail Z-Index */
  --vnsc-z-context-rail: 55;
  --vnsc-z-context-rail-content: 56;

  /* PAT Token Modal Z-Index */
  --vnsc-z-pat-modal: 100;
  --vnsc-z-pat-modal-content: 101;
}`, "",{"version":3,"sources":["webpack://./src/widget/styles/tokens/z-index.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B,0BAA0B;;AAE1B;8EAC8E;AAC9E;EACE,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,aAAa;EACb,aAAa;EACb,aAAa;EACb,aAAa;EACb,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;;EAEf,4BAA4B;EAC5B,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;;EAEtB,+BAA+B;EAC/B,wBAAwB;EACxB,0BAA0B;EAC1B,4BAA4B;EAC5B,0BAA0B;EAC1B,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,yBAAyB;EACzB,+BAA+B;;EAE/B,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,wBAAwB;EACxB,4BAA4B;EAC5B,8BAA8B;EAC9B,yBAAyB;EACzB,iCAAiC;;EAEjC,kBAAkB;EAClB,0BAA0B;EAC1B,2BAA2B;EAC3B,mBAAmB;EACnB,2BAA2B;;EAE3B,qBAAqB;EACrB,6BAA6B;EAC7B,qBAAqB;EACrB,6BAA6B;;EAE7B,mBAAmB;EACnB,2BAA2B;;EAE3B,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;;EAEvB,oBAAoB;EACpB,oBAAoB;EACpB,6BAA6B;EAC7B,4BAA4B;;EAE5B,yBAAyB;EACzB,yBAAyB;EACzB,iCAAiC;;EAEjC,yBAAyB;EACzB,yBAAyB;EACzB,gCAAgC;EAChC,iCAAiC;EACjC,gCAAgC;;EAEhC,2BAA2B;EAC3B,4BAA4B;EAC5B,oCAAoC;EACpC,iCAAiC;;EAEjC,mCAAmC;EACnC,4BAA4B;EAC5B,oCAAoC;;EAEpC,yBAAyB;EACzB,0BAA0B;EAC1B,kCAAkC;;EAElC,0BAA0B;EAC1B,0BAA0B;EAC1B,kCAAkC;;EAElC,wBAAwB;EACxB,wBAAwB;EACxB,gCAAgC;;EAEhC,yBAAyB;EACzB,yBAAyB;EACzB,iCAAiC;;EAEjC,4BAA4B;EAC5B,uBAAuB;EACvB,+BAA+B;AACjC","sourcesContent":["/* Design Tokens - Z-Index */\r\n/* All --vnsc-z-* tokens */\r\n\r\n/* H0.8: `.vnsc-root` — the document-root selector never matches inside the\r\n   widget's Shadow DOM (useShadowDOM defaults on), so tokens resolved to \"\". */\r\n.vnsc-root {\r\n  /* Base Z-Index Scale */\r\n  --vnsc-z-0: 0;\r\n  --vnsc-z-1: 1;\r\n  --vnsc-z-2: 2;\r\n  --vnsc-z-3: 3;\r\n  --vnsc-z-4: 4;\r\n  --vnsc-z-5: 5;\r\n  --vnsc-z-10: 10;\r\n  --vnsc-z-20: 20;\r\n  --vnsc-z-30: 30;\r\n  --vnsc-z-40: 40;\r\n  --vnsc-z-50: 50;\r\n\r\n  /* Semantic Z-Index Layers */\r\n  --vnsc-z-background: 0;\r\n  --vnsc-z-content: 1;\r\n  --vnsc-z-raised: 10;\r\n  --vnsc-z-overlay: 20;\r\n  --vnsc-z-modal: 30;\r\n  --vnsc-z-popover: 40;\r\n  --vnsc-z-tooltip: 50;\r\n  --vnsc-z-toast: 60;\r\n  --vnsc-z-maximum: 9999;\r\n\r\n  /* Component-specific Z-Index */\r\n  --vnsc-z-chart-canvas: 1;\r\n  --vnsc-z-chart-overlay: 10;\r\n  --vnsc-z-chart-crosshair: 15;\r\n  --vnsc-z-chart-tooltip: 20;\r\n  --vnsc-z-chart-drawing: 25;\r\n  --vnsc-z-chart-selection: 30;\r\n  --vnsc-z-chart-measurement: 35;\r\n  --vnsc-z-chart-x-axis: 40;\r\n  --vnsc-z-chart-pane-tooltip: 45;\r\n\r\n  --vnsc-z-toolbar: 50;\r\n  --vnsc-z-header: 55;\r\n  --vnsc-z-footer: 55;\r\n  --vnsc-z-dock: 60;\r\n  --vnsc-z-dock-flyout: 65;\r\n  --vnsc-z-drawing-toolbar: 70;\r\n  --vnsc-z-drawing-inspector: 75;\r\n  --vnsc-z-drawing-list: 75;\r\n  --vnsc-z-drawing-context-menu: 80;\r\n\r\n  --vnsc-z-panel: 85;\r\n  --vnsc-z-panel-content: 90;\r\n  --vnsc-z-modal-backdrop: 95;\r\n  --vnsc-z-modal: 100;\r\n  --vnsc-z-modal-content: 105;\r\n\r\n  --vnsc-z-popover: 110;\r\n  --vnsc-z-popover-content: 115;\r\n  --vnsc-z-tooltip: 120;\r\n  --vnsc-z-tooltip-content: 125;\r\n\r\n  --vnsc-z-toast: 130;\r\n  --vnsc-z-toast-content: 135;\r\n\r\n  --vnsc-z-ads-banner: 95;\r\n  --vnsc-z-ads-popup: 99;\r\n  --vnsc-z-trademark: 100;\r\n\r\n  /* Sidebar Z-Index */\r\n  --vnsc-z-sidebar: 48;\r\n  --vnsc-z-sidebar-splitter: 49;\r\n  --vnsc-z-sidebar-content: 50;\r\n\r\n  /* Bottom Panel Z-Index */\r\n  --vnsc-z-bottom-panel: 40;\r\n  --vnsc-z-bottom-panel-content: 41;\r\n\r\n  /* Drawing Dock Z-Index */\r\n  --vnsc-z-drawing-dock: 50;\r\n  --vnsc-z-drawing-dock-header: 51;\r\n  --vnsc-z-drawing-dock-content: 52;\r\n  --vnsc-z-drawing-dock-flyout: 55;\r\n\r\n  /* Settings Modal Z-Index */\r\n  --vnsc-z-settings-modal: 100;\r\n  --vnsc-z-settings-modal-content: 101;\r\n  --vnsc-z-settings-modal-tabs: 102;\r\n\r\n  /* Snapshot Preview Modal Z-Index */\r\n  --vnsc-z-snapshot-modal: 100;\r\n  --vnsc-z-snapshot-modal-content: 101;\r\n\r\n  /* Alerts Modal Z-Index */\r\n  --vnsc-z-alerts-modal: 100;\r\n  --vnsc-z-alerts-modal-content: 101;\r\n\r\n  /* Symbol Search Z-Index */\r\n  --vnsc-z-symbol-search: 80;\r\n  --vnsc-z-symbol-search-results: 81;\r\n\r\n  /* Whale Panel Z-Index */\r\n  --vnsc-z-whale-panel: 60;\r\n  --vnsc-z-whale-panel-content: 61;\r\n\r\n  /* Context Rail Z-Index */\r\n  --vnsc-z-context-rail: 55;\r\n  --vnsc-z-context-rail-content: 56;\r\n\r\n  /* PAT Token Modal Z-Index */\r\n  --vnsc-z-pat-modal: 100;\r\n  --vnsc-z-pat-modal-content: 101;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
